import httpInstance from "../httpInstance";

export const postLogin = async (userEmail: string, userPwd: string) => {
    let res: any;
    const endpoint = `login/`;

    // Configura el body con el id del recurso
    const data = {
        email: `${userEmail}`,
        password: `${userPwd}`
    }

    await httpInstance.post(endpoint, data)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const postLogout = async (jwtToken: string) => {
    let res: any;
    const endpoint = `logout/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`
        }
    };

    await httpInstance.post(endpoint, null, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const postRegister = async (userName: string, userLastName: string, userEmail: string, userPwd: string, organization: string) => {
    let res: any;
    const endpoint = `users/`;

    // Configura el body con el id del recurso
    const data = {
        name: `${userName}`,
        lastname: `${userLastName}`,
        email: `${userEmail}`,
        password: `${userPwd}`,
        organization: `${organization}`
    }

    await httpInstance.post(endpoint, data)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const postRecoverPwd = async (userEmail: string) => {
    let res: any;
    const endpoint = `sendRecoveryEmail/`;

    // Configura el body con el id del recurso
    const data = {
        email: `${userEmail}`,
    }

    await httpInstance.post(endpoint, data)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const postUserChangePassword = async (userEmail: string, userCode: string, userPWD: string) => {
    let res: any;
    const endpoint = `restorePassword/`;

    // Configura el body 
    const data = {
        email: `${userEmail}`,
        token: `${userCode}`,
        password: `${userPWD}`,
    }

    await httpInstance.post(endpoint, data)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const postActivateAccount = async (userEmail: string, userCode: string) => {
    let res: any;
    const endpoint = `user/activate/`;

    // Configura el body con el id del recurso
    const data = {
        email: `${userEmail}`,
        code: `${userCode}`,
    }

    await httpInstance.post(endpoint, data)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}